import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withKeys as _withKeys, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "folders cursor-pointer w-full" }
const _hoisted_2 = {
  key: 0,
  class: "breadcrumb"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "crumb-name" }
const _hoisted_5 = {
  key: 0,
  class: "crumb-sep"
}
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "folder-list" }
const _hoisted_8 = ["onClick", "onMouseenter"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "select-indicator"
}
const _hoisted_11 = {
  key: 1,
  class: "select-indicator",
  style: {"border":"1px solid #2a66ff","background-color":"#2a66ff"}
}
const _hoisted_12 = {
  key: 0,
  class: "folder-name"
}
const _hoisted_13 = { class: "dot-btn" }

import { ref, onMounted, reactive, computed } from 'vue'
import { ElIcon, ElMessageBox, ElMessage } from 'element-plus'
import { Folder, Plus, MoreFilled } from '@element-plus/icons-vue'
import { createFolder, getFolderList, } from '@/api/affairs'
import { folderOperate } from '@/api/ResourceMasonry'
//@ts-ignore
import MoveDialog from '@/views/shared/components/MoveDialog.vue'
import { useSdkStore } from '@/stores/sdk'
import { multipleChoiceStore } from "@/stores/multipleChoice"

export default /*@__PURE__*/_defineComponent({
  __name: 'FolderListBase',
  props: {
    rootLabel: { type: String, default: '我的空间' },
    corpCode: { type: String, default: '' }
},
  emits: ['select', 'rename', 'move', 'copy', 'delete'],
  setup(__props, { expose: __expose, emit: __emit }) {

const multipleChoice = multipleChoiceStore()
const props = __props
const SelectFolder = computed(() => multipleChoice.getSelectFolder())
const multipleChoiceShow = computed(() => multipleChoice.multipleChoice)


const isFolderSelected = (id: any) => {
    return SelectFolder.value.includes(id)
}
const onSelect = (item: any) => {
    multipleChoice.setSelectFolder(item.folder_id)
}
const selectonClick = (item: any) => {
    if (multipleChoiceShow.value) {
        onSelect(item)
    }
}









const folders = ref<any[]>([])
const hoverId = ref<any>(null)
const openId = ref<any>(null)
const editingId = ref<any>(null)
const editingName = ref('')
const moveDialogVisible = ref(false)
const moveTarget = ref<any>(null)
const emit = __emit
const folderMap = reactive<any>({})
const currentFolderId = ref('')
const currentFolder = ref({})
const actiontype = ref('move')
const fetchFolders = async (parent_folder_id: string) => {
    multipleChoice.clearSelected()
    try {
        const params: any = { parent_folder_id }
        if (props.corpCode) params.corp_code = props.corpCode
        const res = await getFolderList(params)
        if (res.data?.code === 200) folders.value = res.data.data || []
    } catch { }
}

const onCreateFolder = async () => {
    multipleChoice.clearSelected()
    try {
        const { value } = await ElMessageBox.prompt('请输入文件夹名称', '创建文件夹', { confirmButtonText: '确定', cancelButtonText: '取消' })
        const name = String(value || '').trim()
        if (!name) return
        const payload: any = { name, parent_folder_id: currentFolderId.value }
        if (props.corpCode) payload.corp_code = props.corpCode
        payload.owner_type = props.corpCode ? 'team' : 'user'
        const res = await createFolder(payload)
        if (res.data?.code === 200) {
            ElMessage.success('文件夹已创建')
            await fetchFolders(currentFolderId.value)
        }
    } catch { }
}

onMounted(async () => {
    await fetchFolders('')
})

const onSelectFolder = (f: any) => {
    if (multipleChoiceShow.value) {
        selectonClick(f)
        return
    }
    currentFolderId.value = f.folder_id
    currentFolder.value = f
    fetchFolders(currentFolderId.value)
    findLastChildAndAssign(folderMap, f)
    emit('select', f)
}
const onFolderCommand = (cmd: string, f: any) => {
    if (cmd === 'rename') {
        editingId.value = f.id
        editingName.value = f.name
        return
    }
    if (cmd === 'move') {
        actiontype.value = 'move'
        moveTarget.value = f
        moveDialogVisible.value = true
        return
    }
    if (cmd === 'copy') {
        actiontype.value = 'copy'
        moveTarget.value = f
        moveDialogVisible.value = true
        return
    }
    if (cmd === 'delete') {
        ElMessageBox.confirm(`确认删除文件夹“${f.name}”？删除后不可恢复`, '删除文件夹', {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            await folderOperate({ kind: 'folder', action: 'delete', folder_id: f.folder_id, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
            // emit('delete', f)
            ElMessage.success('文件夹已删除')
            await fetchFolders(currentFolderId.value)
        }).catch(() => { })
        return
    }
    emit(cmd as any, f)
}

let hideTimer: any = null
const onDropdownVisibleChange = (visible: boolean, f: any) => {
    if (visible) {
        openId.value = f.id
        if (hideTimer) {
            clearTimeout(hideTimer)
            hideTimer = null
        }
    } else {
        if (hideTimer) clearTimeout(hideTimer)
        hideTimer = setTimeout(() => {
            if (openId.value === f.id) openId.value = null
            hideTimer = null
        }, 1000)
    }
}

const onConfirmRename = async (f: any) => {
    const name = editingName.value.trim()
    if (!name) {
        editingId.value = null
        return
    }
    const i = folders.value.findIndex(x => x.id === f.id)
    if (i > -1) folders.value[i] = { ...folders.value[i], name }

    editingId.value = null
    folderOperate({ kind: 'folder', action: 'rename', folder_id: f.id, name, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode }).then(res => {
        if (res.data?.code === 200) {

        }
    })
}
const onMoveConfirm = (payload: any) => {
    moveDialogVisible.value = false
    emit('select', currentFolder.value)
    fetchFolders(currentFolderId.value)

}
const refresh = async () => {
    await fetchFolders(currentFolderId.value)
}
__expose({ onCreateFolder, refresh })

const findLastChildAndAssign = (obj: any, newChild: any) => {
    if (!obj.child) {
        obj.child = newChild
    } else {
        findLastChildAndAssign(obj.child, newChild)
    }
}
function deleteChildById(obj: any, targetId: any) {
    if (obj.child) {
        if (obj.child.id === targetId) {
            delete obj.child.child
        } else {
            deleteChildById(obj.child, targetId)
        }
    }
}

const breadcrumb = computed(() => {
    const arr: any[] = [{ name: props.rootLabel, folder_id: '' }]
    let node = (folderMap as any).child
    while (node) {
        arr.push({ name: node.name, folder_id: node.folder_id, id: node.id })
        node = node.child
    }
    return arr
})

const breadcrumbFolder = (item: any) => {
    currentFolderId.value = item.folder_id
    currentFolder.value = item
    if (!item.folder_id) {
        Object.keys(folderMap).forEach(k => delete (folderMap as any)[k])
    }
    emit('select', item)
    deleteChildById(folderMap, item.id)
    fetchFolders(currentFolderId.value)
}

return (_ctx: any,_cache: any) => {
  const _component_Check = _resolveComponent("Check")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (breadcrumb.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(ElIcon), { class: "crumb-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Folder))
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumb.value, (item, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item.folder_id || item.id || idx,
              class: "crumb",
              onClick: ($event: any) => (breadcrumbFolder(item))
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1),
              (idx < breadcrumb.value.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "/"))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, "文件夹（" + _toDisplayString(folders.value.length) + "）", 1),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "folder-card add",
        onClick: onCreateFolder
      }, [
        _createVNode(_unref(ElIcon), { class: "plus-icon" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Plus))
          ]),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "folder-name" }, "创建文件夹", -1))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(folders.value, (f) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["folder-card", { 'selectborder': isFolderSelected(f.folder_id) }]),
          key: f.id,
          onClick: ($event: any) => (onSelectFolder(f)),
          onMouseenter: ($event: any) => (hoverId.value = f.id),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (hoverId.value = null))
        }, [
          _createVNode(_unref(ElIcon), { class: "folder-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Folder))
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["select", { 'multipleChoiceShow': multipleChoiceShow.value }]),
            onClick: _withModifiers(($event: any) => (onSelect(f)), ["stop"])
          }, [
            (!isFolderSelected(f.folder_id))
              ? (_openBlock(), _createElementBlock("span", _hoisted_10))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _createVNode(_unref(ElIcon), { color: "white" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Check)
                    ]),
                    _: 1
                  })
                ]))
          ], 10, _hoisted_9),
          (editingId.value !== f.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(f.name), 1))
            : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                modelValue: editingName.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editingName).value = $event)),
                size: "small",
                class: "folder-input w-[50px] mr-[14px]",
                onKeydown: _withKeys(($event: any) => (onConfirmRename(f)), ["enter"]),
                onBlur: ($event: any) => (onConfirmRename(f))
              }, null, 8, ["modelValue", "onKeydown", "onBlur"])),
          (!multipleChoiceShow.value)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "menu-trigger",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_component_el_dropdown, {
                  trigger: "click",
                  onCommand: ($event: any) => (onFolderCommand($event, f)),
                  onVisibleChange: ($event: any) => (onDropdownVisibleChange($event, f))
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, { command: "rename" }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("重命名", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, { command: "move" }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("移动", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, { command: "copy" }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("复制", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, { command: "delete" }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("删除", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MoreFilled))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["onCommand", "onVisibleChange"])
              ], 512)), [
                [_vShow, hoverId.value === f.id || openId.value === f.id || editingId.value === f.id]
              ])
            : _createCommentVNode("", true)
        ], 42, _hoisted_8))
      }), 128))
    ]),
    _createVNode(MoveDialog, {
      modelValue: moveDialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((moveDialogVisible).value = $event)),
      current: moveTarget.value,
      type: "folder",
      onConfirm: onMoveConfirm,
      action: actiontype.value,
      corpCode: props.corpCode,
      teams: [{ team_name: __props.rootLabel, team_id: __props.corpCode, }]
    }, null, 8, ["modelValue", "current", "action", "corpCode", "teams"])
  ]))
}
}

})